import * as React from 'react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';

import {
  CollapsibleItemsContainer,
  GiftIcon,
  ReactFCC,
} from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';
import { ICampaign } from '@containers/ProductListing/model';

import messages from '../../../../messages';

import { GiftBaseItem } from './GiftBaseItem';
import {
  Title,
  GiftCount,
  CampaignsStyled,
  CampaignsWrapper,
  CollapsibleItemsContainerWrapper,
  Container,
  IconTextWrapper,
  GiftIconWrapper,
} from './styled';

interface IGiftBaseProps {
  containerId: string;
  titleMessage: MessageDescriptor;
  imageMessage: MessageDescriptor;
  campaigns: ICampaign[];
}

export const GiftBase: ReactFCC<IGiftBaseProps> = React.memo(
  ({ imageMessage, containerId, titleMessage, campaigns }) => {
    const newPdDesignEnabled = useNewPdDesignEnabled();
    const { formatMessage } = useIntl();

    const giftsLength = campaigns.length;

    const campaignsComponent = React.useMemo(() => {
      return campaigns.map(
        ({ text, detailPageText, giftImageUrl, ...rest }) => (
          <GiftBaseItem
            key={rest.campaignId}
            descriptionText={detailPageText || text}
            imageUrl={giftImageUrl}
            imageMessage={imageMessage}
          />
        )
      );
    }, [campaigns, imageMessage]);

    return (
      <Container
        id={containerId}
        newDesign={newPdDesignEnabled}
        data-testid="gift-base"
      >
        <IconTextWrapper newDesign={newPdDesignEnabled}>
          <GiftIconWrapper>
            <GiftIcon width="20px" height="20px" />
          </GiftIconWrapper>

          <Title newPdDesignEnabled={newPdDesignEnabled}>
            <FormattedMessage {...titleMessage} />
          </Title>
          {giftsLength > 1 ? <GiftCount>({giftsLength})</GiftCount> : null}
        </IconTextWrapper>

        <CampaignsWrapper>
          <CollapsibleItemsContainerWrapper>
            <CollapsibleItemsContainer
              collapseTextButton={formatMessage(messages.showLessGifts)}
              expandTextButton={formatMessage(messages.showMoreGifts)}
              itemsToShow={2}
            >
              {campaignsComponent}
            </CollapsibleItemsContainer>
          </CollapsibleItemsContainerWrapper>

          <CampaignsStyled isOneCampaign={campaigns.length === 1}>
            {campaignsComponent}
          </CampaignsStyled>
        </CampaignsWrapper>
      </Container>
    );
  }
);
